export class SupportRequest {
    public description: string = ''
    public priority: string = ''
    public metadata: any = {}
}
